export default "__VITE_ASSET__ruJ7x4HV__"